import type { Id, Item } from './types'

export const getIds = <T extends Item<Id>>(items: T[]): Id[] =>
  items.map(({ id }) => id)
